//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import QRCode from 'qrcodejs2';
import { orderResultApi } from '@/api/system';
export default {
  name: 'Payment',
  props: {
    fromData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      openStatus: false,
      payType: [{
        name: '微信支付',
        id: 1
      }],
      activeIndex: 0,
      loading: false,
      width: 190,
      height: 190,
      qrcode: null,
      timer: null
    };
  },
  computed: {},
  watch: {
    fromData: {
      handler: function handler(nVal) {
        this.getQRCode(nVal.data.wxpay_url);
        this.createSetInterval(nVal.data.order_id);
      },
      deep: true
    }
  },
  mounted: function mounted() {},
  methods: {
    handleClose: function handleClose() {
      this.$refs.QRCode_header.innerHTML = '';
      this.stopSetInterval();
      this.dialogVisible = false;
    },
    handleOpen: function handleOpen() {
      this.dialogVisible = true;
    },
    tabPay: function tabPay(index) {
      this.activeIndex = index;
    },
    getOrderResult: function getOrderResult(order_id) {
      var _this = this;
      orderResultApi(order_id).then(function (res) {
        if (res.status == 200) {
          _this.handleClose();
          _this.$emit('isOk');
        }
      }).catch(function (error) {});
    },
    createSetInterval: function createSetInterval(order_id) {
      var _this2 = this;
      this.stopSetInterval();
      this.timer = setInterval(function () {
        _this2.getOrderResult(order_id);
      }, 2000);
    },
    stopSetInterval: function stopSetInterval() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    getQRCode: function getQRCode(url) {
      var _this3 = this;
      this.$nextTick(function () {
        _this3.qrcode = new QRCode(_this3.$refs.QRCode_header, {
          text: url,
          width: 190,
          height: 190,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        });
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.stopSetInterval();
  }
};